import { render, staticRenderFns } from "./NewOrderModal.vue?vue&type=template&id=56b05496&"
import script from "./NewOrderModal.vue?vue&type=script&lang=js&"
export * from "./NewOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports